{
  "help.title": "Guida",
  "help.subtitle": "Come si usa Praesto, schermata per schermata.",
  "help.open": "Apri la guida",
  "help.openFull": "Apri la guida completa",
  "help.contextual": "Aiuto per questa schermata",
  "help.search": "Cerca nella guida…",
  "help.noResults": "Nessun risultato. Prova con un'altra parola.",
  "help.seeAlso": "Vedi anche",
  "help.backToIndex": "Torna all'indice",
  "help.loading": "Caricamento…",
  "help.indexHint": "Scegli un argomento, oppure cerca.",
  "help.section.start": "Primo accesso",
  "help.section.orientation": "Orientarsi",
  "help.section.home": "Home",
  "help.section.procedure": "Procedure",
  "help.section.shifts": "Turni",
  "help.section.monitoring": "Monitoraggio",
  "help.section.reservations": "Prenotazioni",
  "help.section.automation": "Automazioni",
  "help.section.people": "Persone",
  "help.section.leaves": "Ferie e permessi",
  "help.section.settings": "Impostazioni",
  "help.start.login.title": "Accedere alla tua struttura",
  "help.start.login.summary": "L'indirizzo da usare, e cosa fare se la pagina non ti riconosce.",
  "help.start.multiOrg.title": "Più organizzazioni sulla stessa email",
  "help.start.multiOrg.summary": "Se lavori per più di un'organizzazione, come scegliere quale aprire.",
  "help.start.password.title": "Password dimenticata",
  "help.start.password.summary": "Richiedere il link di reset e impostare la nuova password.",
  "help.start.firstOwner.title": "Primo accesso da titolare",
  "help.start.firstOwner.summary": "Il percorso guidato iniziale e i dati di esempio.",
  "help.orientation.desktop.title": "L'app da computer",
  "help.orientation.desktop.summary": "Le due barre laterali, la barra in alto, dove trovare le cose.",
  "help.orientation.mobile.title": "L'app dal telefono",
  "help.orientation.mobile.summary": "La barra in basso, il menu Altro, e cosa dal telefono non c'è.",
  "help.orientation.hotelSwitch.title": "Cambiare struttura",
  "help.orientation.hotelSwitch.summary": "Passare da una struttura all'altra quando ne gestisci più di una.",
  "help.orientation.notifications.title": "Notifiche",
  "help.orientation.notifications.summary": "La campanella, l'elenco, e come attivarle su questo dispositivo.",
  "help.orientation.search.title": "Ricerca rapida",
  "help.orientation.search.summary": "Aprire qualsiasi schermata senza cercarla nei menu.",
  "help.home.todayWeek.title": "Home: Oggi e Settimana",
  "help.home.todayWeek.summary": "Il quadro della giornata e la vista dei prossimi giorni.",
  "help.home.activityProfile.title": "Attività e Profilo",
  "help.home.activityProfile.summary": "Cosa è successo di recente e dove stanno i tuoi dati.",
  "help.procedure.browse.title": "Consultare le procedure",
  "help.procedure.browse.summary": "Trovare la procedura giusta e leggerla durante il servizio.",
  "help.procedure.create.title": "Creare una procedura",
  "help.procedure.create.summary": "Da zero, da un modello, o importando un PDF.",
  "help.procedure.versions.title": "Bozza, pubblicazione e versioni",
  "help.procedure.versions.summary": "Perché le modifiche non sono subito visibili, e come tornare indietro.",
  "help.procedure.attachments.title": "Allegati",
  "help.procedure.attachments.summary": "Aggiungere file a una procedura.",
  "help.procedure.assistant.title": "L'assistente AI",
  "help.procedure.assistant.summary": "Fare domande a voce vostra, e perché la prima risposta è lenta.",
  "help.shifts.mine.title": "I miei turni",
  "help.shifts.mine.summary": "Vedere i propri turni dal telefono, e cosa fare se non li trovi.",
  "help.shifts.grid.title": "La griglia di pianificazione",
  "help.shifts.grid.summary": "Scale, raggruppamenti, filtri e viste salvate.",
  "help.shifts.planner.title": "Il planner AI",
  "help.shifts.planner.summary": "Far proporre la settimana, e cosa il planner tiene in conto.",
  "help.shifts.templates.title": "Modelli di turno",
  "help.shifts.templates.summary": "Preparare i turni ricorrenti una volta sola.",
  "help.shifts.availability.title": "Disponibilità",
  "help.shifts.availability.summary": "Dichiarare i giorni in cui non si può lavorare.",
  "help.shifts.publish.title": "Pubblicare la settimana",
  "help.shifts.publish.summary": "Cosa succede alla pubblicazione, e perché a volte viene respinta.",
  "help.monitoring.today.title": "Le attività di oggi",
  "help.monitoring.today.summary": "Svolgere un'attività e allegare le foto.",
  "help.monitoring.templates.title": "Modelli di attività",
  "help.monitoring.templates.summary": "Definire cosa va controllato, da chi e quando.",
  "help.monitoring.reports.title": "Segnalazioni",
  "help.monitoring.reports.summary": "Aprire, assegnare, prendere in carico e risolvere.",
  "help.monitoring.handover.title": "Cambio turno",
  "help.monitoring.handover.summary": "Passare le consegne, e come funziona dopo la mezzanotte.",
  "help.monitoring.dashboard.title": "Dashboard e storico",
  "help.monitoring.dashboard.summary": "Cosa è stato fatto, da chi, con i commenti.",
  "help.people.add.title": "Aggiungere una persona",
  "help.people.add.summary": "Invito via email oppure password consegnata a voce.",
  "help.people.roles.title": "Ruoli e permessi",
  "help.people.roles.summary": "Chi vede cosa, e chi può modificare cosa.",
  "help.people.structure.title": "Strutture e reparti",
  "help.people.structure.summary": "Creare le strutture e organizzarle in reparti.",
  "help.people.profile.title": "La scheda di una persona",
  "help.people.profile.summary": "Info, competenze, disponibilità, ferie e carico di lavoro.",
  "help.leaves.requestApprove.title": "Ferie e permessi",
  "help.leaves.requestApprove.summary": "Richiederli da dipendente, approvarli da responsabile.",
  "help.settings.personal.title": "Le tue preferenze",
  "help.settings.personal.summary": "Notifiche per tipo, canali, dispositivi.",
  "help.settings.tenant.title": "Impostazioni della struttura",
  "help.settings.tenant.summary": "Durata della sessione, moduli attivi, regole di notifica.",
  "help.settings.integrations.title": "Integrazioni con il gestionale del personale",
  "help.settings.integrations.summary": "Collegare un gestionale esterno e importare le persone.",
  "help.loadFailed": "Non riesco a caricare la guida. Controlla la connessione e riprova.",
  "help.retry": "Riprova",
  "help.reservations.day.title": "La giornata delle prenotazioni",
  "help.reservations.day.summary": "Chi parte, chi arriva, chi resta.",
  "help.automation.rules.title": "Le automazioni",
  "help.automation.rules.summary": "Regole che creano e assegnano il lavoro da sole.",
  "help.reservations.planner.title": "Il planner",
  "help.reservations.planner.summary": "Leggere l'albergo dall'alto: chi c'è, camera per camera.",
  "help.monitoring.assignments.title": "Assegnare il lavoro",
  "help.monitoring.assignments.summary": "La giornata di chi distribuisce: chi fa cosa, e chi non l'ha ancora preso."
}
